export const COIN_LIST = ['BTC', 'ETH', 'BNB', 'ADA', 'SOL', 'DOT', 'AVAX', 'ATOM', 'ARB', 'SYN'];
